import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import NewSearchSateInput from "../../NewSearchSateInput/NewSearchSateInput";
import DatePicker from "react-datepicker";
import styles from "./NewAgentSearchPage.module.scss";
import { SvgRightIcon, SvgSearch } from "../../../utils/svgIcons";
import { format } from "date-fns";
import HomePageNewSearchSateInput from "../../NewSearchSateInput/HomePageNewSearchSateInput";

function NewUIAgentSearchFormHolidays({ topRadios }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dataFromChild, setDataFromChild] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [show, setShow] = useState(false);
  const [showGuestDetailsPopup, setShowGuestDetailsPopup] = useState(false);

  const getDataFromChild = (data, resultArray, selectedType) => {
    setDataFromChild(data);
    setSelectedType(selectedType);
    // setStateResultArray(resultArray)
  };

  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // console.log("isLoggedIn", isLoggedIn);

  const [guestDetails, setIsguestDetails] = useState(false);
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectDates, setselectDates] = useState(false);

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const location = useLocation();
  const navigate = useNavigate();

  // STATES
  const [date, setDate] = useState(new Date());
  const [selectedRadio, setSelectedRadio] = useState("");

  const [data, setData] = useState({
    fromCity: "",
    toCity: "",
  });
  //
  const [guest, setGuest] = useState(2);

  // Date alterations
  const [loader, setLoader] = useState(false);

  const handleSubmitButtonClickHandler = async (e) => {
    setIsguestDetails(false);
    setdestinationToggle(false);
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    // console.log(children, "children");

    try {
      await navigate(
        `/agent-search?location=${dataFromChild}&guest=${guest}&children=${children}&${childAgeParams}&day=${date.getDate()}&month=${
          date.getMonth() + 1
        }&year=${date.getFullYear()}&radio=${selectedRadio}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerPackage = async (e) => {
    setIsguestDetails(false);
    setdestinationToggle(false);
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    try {
      await navigate(
        `/single-package-search/${selectedType?.packagehandle}?packageId=${selectedType?.id}&location=${data.fromCity}&guest=${guest}&children=${children}&${childAgeParams}`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);

  const availableAges = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  // Function to add a child's age
  const handleAddChildAge = (age) => {
    setChildAge((prevAges) => {
      const newAges = [...prevAges, age];
      setChildren(newAges.length);
      return newAges;
    });
    setShowGuestDetailsPopup(false);
  };

  // Function to remove a child's age
  const handleRemoveChild = (indexToRemove) => {
    setChildAge((prevAges) => {
      const newAges = prevAges.filter((_, index) => index !== indexToRemove);
      setChildren(newAges.length);
      return newAges;
    });
  };

  return (
    <>
      <section
        onClick={() => setShow(false)}
        className={styles.NewUiSearchWrapper}
        id="home"
      >
        <div className={styles.NewUiSearchParent}>
          <div
            className=""
            style={
              guestDetails || destinationToggle
                ? { zIndex: "999" }
                : { position: "" }
            }
          >
            <form
              className={styles.NewUiSearchFormWrapper}
              onSubmit={
                selectedType?.type === "package"
                  ? handleSubmitButtonClickHandlerPackage
                  : handleSubmitButtonClickHandler
              }
            >
              <div className={styles.widthOfDestination}>
                <label htmlFor="">Destination/Package</label>
                <HomePageNewSearchSateInput
                  onClick={() => setdestinationToggle(true)}
                  onDataChange={getDataFromChild}
                  dropdownGuestDetails={dropdownGuestDetails}
                  setIsguestDetails={setIsguestDetails}
                  type="package"
                />
              </div>
              <div
                className={`${styles.leftLineBorder} new_date_picker_react_js_custom_styling`}
              >
                <label>Dates</label>
                <div className={styles.new_date_picker_wrapper}>
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                    dateFormat="dd MMM, yyyy"
                    placeholderText={
                      date ? format(date, "dd MMM, yyyy") : "Travel Date"
                    }
                  />
                </div>
              </div>
              <div className={styles.leftLineBorder}>
                <label onClick={dropdownGuestDetails} className="search_label">
                  Guests{" "}
                  <svg
                    width="9"
                    height="5"
                    viewBox="0 0 9 5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8.25 0.75L4.75 4.25L1.25 0.75" stroke="#BB735D" />
                  </svg>
                </label>
                <div
                  style={{ position: "relative" }}
                  className="dropdown-toggle search_form_input"
                  onClick={() => setdestinationToggle(true)}
                >
                  <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                    <div className="optionCounter"></div>
                    <span id="adult_count" className="font_16">
                      {" "}
                      {guest}
                    </span>
                    <span className="font_12"> Guests, </span>
                    <span id="child_count" className="font_16">
                      {children}
                    </span>
                    <span className="font_12"> Children</span>
                  </div>
                  {guestDetails && (
                    <div
                      className="guest_details_dropdown"
                      id="guestDetailsPopup"
                    >
                        <div className="agent">
                        <span>Guests</span>
                        <div className="flex align_items_center">
                          <button
                            type="button"
                            disabled={guest <= 1}
                            className="optionCounterButton optionCounterButtonWithBorder"
                            onClick={() => {
                              if (guest <= 2) return;
                              setGuest(Number(guest) - 1);
                            }}
                          >
                            <span className="onclick_btn" id="adult_minus">
                              -
                            </span>
                          </button>

                          <input
                            className="optionCounterNumber gueestInputNewUI"
                            value={guest}
                            min={1}
                            type="number"
                            // onChange={(e) => setGuest(e.target.value)}
                            onChange={(e) => {
                              let value = Number(e.target.value);
                              if (isNaN(value)) return;
                              setGuest(Math.min(11, Math.max(2, value)));
                            }}
                          />

                          <button
                            type="button"
                            disabled={guest >= 11}
                            className="optionCounterButton optionCounterButtonWithBorder"
                            onClick={() => {
                              if (guest >= 11) return;
                              setGuest(Number(guest) + 1);
                            }}
                          >
                            <span className="onclick_btn" id="adult_plus">
                              +
                            </span>
                          </button>
                        </div>
                      </div>

                      {/* {childAge.map((age, index) => (
                              <div className="navbar agent">
                                <div>
                                  <span>Child Age</span>
                                </div>
                                <div>
                                  <input
                                    className="childAge_input"
                                    type="number"
                                    name="childAge[]"
                                    min="1"
                                    value={age}
                                    onChange={(event) =>
                                      handleChildrenAgeChange(index, event)
                                    }
                                    required
                                  />
                                </div>
                              </div>
                            ))} */}

                      <div>
                        {childAge.map((age, index) => (
                          <div
                            className="agent flex items-center gap-2"
                            key={index}
                          >
                            <span>
                              Child{" "}
                              <small style={{ fontSize: "12px" }}>
                                {" "}
                                ({age} Yrs){" "}
                              </small>
                            </span>
                            <div
                              className="remove_svg"
                              onClick={() => handleRemoveChild(index)}
                            >
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_6577_13294"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect width="18" height="18" />
                                </mask>
                                <g mask="url(#mask0_6577_13294)">
                                  <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                                </g>
                              </svg>
                            </div>
                          </div>
                        ))}

                        {/* Add a child button */}
                        <div
                          className="flex align_items_center justify_content_between border"
                          style={{
                            padding: "10px ",
                            marginBottom: "10px",
                            fontWeight: "400",
                          }}
                          onClick={() =>
                            setShowGuestDetailsPopup(!showGuestDetailsPopup)
                          }
                        >
                          Add a Child
                          <div>
                            <svg
                              width="12"
                              height="6"
                              viewBox="0 0 12 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </div>
                        </div>

                        {/* Child age selection popup */}
                        {showGuestDetailsPopup && (
                          <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                            {availableAges.map((age, i) => (
                              <div
                                className="new-age-option"
                                key={i}
                                onClick={() => handleAddChildAge(age)}
                                style={{ fontWeight: "400" }}
                              >
                                {age} Years
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.searchButtonDiv}>
                <button type="submit" className={styles.submitButton}>
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_6855_8179"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                      >
                        <rect width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6855_8179)">
                        <path
                          d="M13.0284 13.7178L8.8412 9.53051C8.50787 9.80574 8.12453 10.0211 7.6912 10.1767C7.25786 10.3322 6.80959 10.41 6.34636 10.41C5.20692 10.41 4.24259 10.0155 3.45336 9.22651C2.66414 8.43751 2.26953 7.4734 2.26953 6.33418C2.26953 5.19507 2.66403 4.23063 3.45303 3.44085C4.24203 2.65118 5.20614 2.25635 6.34536 2.25635C7.48448 2.25635 8.44892 2.65096 9.2387 3.44018C10.0284 4.2294 10.4232 5.19374 10.4232 6.33318C10.4232 6.80929 10.3433 7.26401 10.1835 7.69735C10.0236 8.13068 9.81036 8.50757 9.5437 8.82801L13.7309 13.0152L13.0284 13.7178ZM6.34636 9.41018C7.20536 9.41018 7.93292 9.11207 8.52903 8.51585C9.12525 7.91974 9.42336 7.19218 9.42336 6.33318C9.42336 5.47418 9.12525 4.74662 8.52903 4.15051C7.93292 3.55429 7.20536 3.25618 6.34636 3.25618C5.48736 3.25618 4.75981 3.55429 4.1637 4.15051C3.56748 4.74662 3.26936 5.47418 3.26936 6.33318C3.26936 7.19218 3.56748 7.91974 4.1637 8.51585C4.75981 9.11207 5.48736 9.41018 6.34636 9.41018Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {(guestDetails || destinationToggle || selectDates) && (
        <div
          onClick={() => [
            setIsguestDetails(false),
            setdestinationToggle(false),
            setselectDates(false),
          ]}
          className="ScreenDimmer"
        ></div>
      )}
    </>
  );
}

export default NewUIAgentSearchFormHolidays;
